const { RichText, InnerBlocks } = wp.blockEditor;

const Save = ({ attributes }) => {
  const { title, description, target, nameButton } = attributes;

  return (
    <div className="swiperContentPlans swiper-slide">
      <div className="CardPlan TabsCompany__content">
        <div className="CardPlan-price TabsCompany__information">
          <RichText.Content
            tagName="h3"
            // className="CardPlan-title TabsCompany__cardTitle"
            className="Typography title-5 left color-blue-dark margin-base"
            value={title}
          />
          <RichText.Content
            tagName="p"
            // className="TabsCompany__cardDescription"
            className="Typography text left color-black margin-base"
            value={description}
          />
        </div>

        <nav className="CardPlan-list TabsCompany__content-list">
          <ul>
            <InnerBlocks.Content />
          </ul>
        </nav>

        {nameButton && (
          <a
            title="Proposta"
            className={
              target
                ? 'Button CardPlan-link request-proposal ModalForm-open'
                : 'Button CardPlan-link request-proposal'
            }
            href="#"
          >
            <RichText.Content value={nameButton} />
          </a>
        )}
      </div>
    </div>
  );
};

export default Save;
